import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import CategoryManagerState from "@/modules/category-manager";

export const FocusWordsAssociationResolver = async function (to: Route, form: Route, next: Function) {
	const titleListModule = getModule(TitleListState);
	const categoryModule = getModule(CategoryManagerState);
	const actions: Promise<void>[] = [];

	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!titleListModule.tags.length) {
		actions.push(titleListModule.fetchVcsTags());
	}
	if (!categoryModule.categories.length) {
		actions.push(categoryModule.fetchCategories());
	}
	if (to.params.id) {
		actions.push(titleListModule.fetchContentDetails(to.params.id));
	}
	await Promise.all(actions);
	next();
};
